<template>
	<div v-if="config">
		Qualities
		<div v-for="(info, name) in config" style="border-bottom: 1px solid #AAA;">
			<v-text-field v-model="name" label="Name"></v-text-field>
		</div>
		{{value}}
	</div>
</template>

<script>
export default {
	props: ["value"],
	data () {
		return {
			config: this.value
		}
	},
	created: function() {
		this.$watch("config", function(newVal) {
			this.$emit("input", newVal);
		}, {deep: true})
	}
}
</script>